/* OKCA.samples: pack de 3 muestras personalizadas con el top 3 ya elegido.
   Mismo formato de propiedades que snippets/sample-selector-block.liquid
   (el picking del almacen lo lee; no cambiar claves ni guion). */
(function () {
  'use strict';
  window.OKCA = window.OKCA || {};

  // Pack de 3 que usa el selector de la tienda (activo, sin etiqueta no-selector-muestras)
  var HANDLE = 'pack-3-muestras';
  var cache = null;

  function raiz() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  // Nombre solo desde t/_ref; nunca se leen real ni marca.
  function nombre(p) {
    var n = p && p._ref;
    if (!n && p && p.t) n = String(p.t).replace(/^\s*[A-Za-z0-9]+\s*[-–—]\s*/, '');
    n = String(n || '').replace(/^\s*(recuerda a|inspirado en)\s+/i, '').replace(/^\s+|\s+$/g, '');
    return n;
  }

  function codigo(p) {
    if (p && p._code) return String(p._code);
    var m = p && p.t ? String(p.t).match(/^\s*([A-Za-z0-9]+)\s*[-–—]/) : null;
    return m ? m[1] : '';
  }

  function load() {
    if (cache) return cache;
    cache = fetch(raiz() + 'products/' + HANDLE + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('pack ' + r.status); return r.json(); })
      .then(function (p) {
        var v = null, i;
        for (i = 0; i < (p.variants || []).length; i++) {
          if (p.variants[i].available) { v = p.variants[i]; break; }
        }
        v = v || (p.variants && p.variants[0]);
        return { variantId: v ? v.id : null, price: v ? v.price : null, available: !!(v && v.available) };
      })
      .catch(function () { cache = null; return { variantId: null, price: null, available: false }; });
    return cache;
  }

  function add(products) {
    var lista = (products || []).slice(0, 3);
    return load().then(function (info) {
      if (!info.available || !info.variantId) throw new Error('Pack de muestras no disponible');
      var props = { '_okp_origen': 'compra-asistida-muestras' };
      lista.forEach(function (p, i) {
        var c = codigo(p), n = nombre(p);
        // Formato: «AVT – recuerda a Aventus Creed» (guion medio)
        props['Muestra ' + (i + 1) + ' (2 mL)'] = c + (n ? ' – recuerda a ' + n : '');
      });
      return fetch(raiz() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: info.variantId, quantity: 1, properties: props })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || ('add ' + r.status));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          return d;
        });
      });
    });
  }

  window.OKCA.samples = { handle: HANDLE, load: load, add: add };
})();
